const requestUrl = process.env.BASE_URL

export const requestConfig = {
    url: requestUrl,
    // url: 'http://127.0.0.1:8081',
    // url: '/proxy',
    timeout: 30000
}



// WEBPACK FOOTER //
// ./src/api/index.js